<modal
    [id]="'unsaved-changes'"
    [(visible)]="isVisible"
    [title]="'uiKit.miscs.unsavedChangesModal.unsavedChangesModalTitle'"
    [severity]="'danger'"
    [includeCancelButton]="true"
    [cancelButtonLabel]="'uiKit.miscs.unsavedChangesModal.leaveWithoutSaving'"
    [cancelButtonSeverity]="'danger'"
    [includeConfirmButton]="true"
    [confirmButtonLabel]="'uiKit.miscs.unsavedChangesModal.continueEditing'"
    [confirmButtonSeverity]="'primary'"
    (onCancel)="leavePage.emit()"
    (onConfirm)="onClose.emit()">
    <p>{{ unsavedChangesModalScopeText() | translate }}</p>
    <p>{{ 'uiKit.miscs.unsavedChangesModal.unsavedChangesModalText2' | translate }}</p>
</modal>
